import { useEffect } from 'react'
import { useQuery, useMutation, useLazyQuery } from '@apollo/react-hooks'

import {
  // GET_REWARD,
  // GET_REWARDS_DATA,
  // GET_QUIZ_QUESTIONS,
  // GET_QUESTIONS,
  // GET_USER_EVENT,
  GET_EVENTS,
  // GET_USER,
  // GET_HOMEPAGE,
  // GET_APPS,
  // GET_VIDEOS,
  // GET_QUIZ_CATEGORIES,
  // GET_QUIZZES,
  // GET_LEADERBOARD,
  GET_PROFILE,
  GET_FAQS,
  // GET_RESULT,
  // GET_DASHBOARD_DATA,
  // GET_TAGS,
  // GET_SCRATCH_CARDS_DATA,
  GET_ONBOARDING_STATUS,
  GET_VIDEO,
  BANNER,
  FETCH_BONUS_ACTIVITY,
  BONUS_ACTIVITY,
  GET_QUIZ_QUESTION,
  GET_QUESTION_BY_NUMBER,
  GET_WORKSHEET,
  GET_SHEET_BY_ID,
  GET_PARENT_SCREEN,
  GET_KID_ASSESSMENT_QUESTION,
  GET_REWARDS,
  GET_CHILD_PERFORMANCE,
  GET_FAMILY_PROGRESS,
  GET_WINNER_SCREEN,
  GET_LEADERBOARD_DATA,
  GET_LEADERBOARDS_DATA,
  GET_WEEKLY_VIDEOS_STATUS,
  GET_WEEKLY_QUIZ_STATUS,
  GET_WEEKLY_WORKSHEET_STATUS,
  GET_CURRENT_WEEK,
  GET_MONTHLY_LEADERBOARD,
  GET_BANNER_CAROUSEL,
  GET_SCRATCH_CARDS_DATA,
  GET_HOME_BANNERS,
} from '../resources/queries'
import {
  CREATE_REWARD,
  UPDATE_USER,
  // SAVE_EVENT,
  // CALCULATE_RESULT,
  CREATE_OTP,
  VERIFY_OTP,
  UPDATE_USER_AGE,
  UPDATE_VIDEO_DATA,
  SUBMIT_QUIZ_QUES_RESULT,
  SUBMIT_SCREENER,
  SUBMIT_WORKSHEET,
  GET_APP_REWARDS,
  SUBMIT_TIMEDATA,
  SEND_WORKSHEET_DATA,
  SEND_QUIZ_DATA,
  SEND_ASSESSMENT_DATA,
  SEND_BONUS_DATA,
  SEND_VIDEOS_DATA,
  SEND_PARENT_DATA,
} from '../resources/mutations'

export function useQueryEvents({ filter, limit, offset }) {
  const { loading, error, data, refetch, fetchMore } = useQuery(GET_EVENTS, {
    variables: { filter, limit, offset },
    fetchPolicy: 'cache-and-network',
  })
  return { loading, error, data, refetch, fetchMore }
}

// export function useGetEvent(trigger, filter) {
//   const [getEvent, { loading, error, data }] = useLazyQuery(GET_USER_EVENT)

//   useEffect(() => {
//     getEvent({ variables: { filter } })
//   })

//   return { loading, error, data }
// }

// export function useSaveEvent() {
//   const userId = localStorage.getItem('id')
//   const month = new Date().getMonth()
//   const [addEvent, { loading, error, data }] = useMutation(SAVE_EVENT, {
//     refetchQueries: () => {
//       return [
//         {
//           query: GET_EVENTS,
//           variables: { filter: { userId, type: 'reward' } },
//         },
//         // {
//         //   query: GET_REWARDS_DATA,
//         //   variables: {
//         //     userId,
//         //     identifier: true,
//         //     month,
//         //     filter: { status: true },
//         //     ordersFilter: { user: userId },
//         //   },
//         // },
//       ]
//     },
//   })
//   const saveEvent = (eventData) => addEvent({ variables: { ...eventData } })
//   return [saveEvent, { loading, error, data }]
// }

export function useUpdateProfile(userId) {
  const [updateUser, { loading, error, data }] = useMutation(UPDATE_USER, {
    refetchQueries: () => {
      return [
        {
          query: GET_PROFILE,
          variables: { filter: { userId }, id: userId },
        },
      ]
    },
    // onCompleted: () => redirectToProfile(true),
  })
  const updateProfile = (profile) => updateUser({ variables: { ...profile } })
  return [updateProfile, { loading, error, data }]
}

// export function useQueryQuestions(filter) {
//   const { loading, error, data } = useQuery(GET_QUESTIONS, {
//     variables: { filter },
//   })
//   return { loading, error, data }
// }

// export function useCalculateResult() {
//   const [calculateResult, { loading, error, data }] = useMutation(
//     CALCULATE_RESULT
//   )
//   const calcResult = (filter) => calculateResult({ variables: { ...filter } })
//   return [calcResult, { loading, error, data }]
// }

// export function useGetUser(token) {
//   const [getUser, { loading, error, data }] = useLazyQuery(GET_USER)

//   useEffect(() => {
//     getUser({ variables: { accessToken: token } })
//   }, [token])

//   return { loading, error, data }
// }

// export function useGetHomePage(userId) {
//   const { loading, error, data, refetch } = useQuery(GET_HOMEPAGE, {
//     variables: { filter: { userId } },
//     fetchPolicy: 'cache-and-network',
//   })

//   return { loading, error, data, refetch }
// }

// export function useGetApps({ limit, offset }) {
//   const { loading, error, data, fetchMore, refetch } = useQuery(GET_APPS, {
//     variables: { limit, offset },
//     fetchPolicy: 'cache-and-network',
//   })

//   return { loading, error, data, fetchMore, refetch }
// }

// export function useGetVideos({ limit, offset }) {
//   const { loading, error, data, fetchMore, refetch } = useQuery(GET_VIDEOS, {
//     variables: { limit, offset },
//     // fetchPolicy: 'cache-and-network',
//   })
//   return { loading, error, data, fetchMore, refetch }
// }

// export function useGetQuizCategories() {
//   const { loading, error, data, refetch } = useQuery(GET_QUIZ_CATEGORIES, {
//     variables: { filter: { status: 1 } },
//     fetchPolicy: 'cache-and-network',
//   })
//   return { loading, error, data, refetch }
// }

export function useStatus(id) {
  const { loading, error, data } = useQuery(GET_ONBOARDING_STATUS, {
    variables: { id },
    // fetchPolicy:'cache-and-network'
  })
  return { loading, error, data }
}

// export function useLazyGetQuizzes() {
//   const [getQuizzes, { loading, error, data }] = useLazyQuery(GET_QUIZZES)
//   const getQuizzesFromCategory = (categoryId, userId) =>
//     getQuizzes({
//       variables: { categoryId, userId },
//     })

//   return [getQuizzesFromCategory, { loading, error, data }]
// }

// export function useOnboardingStatus() {
//   const [getOnBoarding, { loading, error, data }] = useLazyQuery(
//     GET_ONBOARDING_STATUS
//   )
//   return [getOnBoarding, { loading, error, data }]
// }

// export function useGetQuizzes(categoryId, userId, status) {
//   const { loading, error, data, refetch } = useQuery(GET_QUIZZES, {
//     variables: { categoryId, userId, status },
//     fetchPolicy: 'network-only',
//   })
//   return { loading, error, data, refetch }
// }

// export function useGetLeaderboard(userId, identifier) {
//   const { loading, error, data } = useQuery(GET_LEADERBOARD, {
//     variables: { userId, identifier },
//     fetchPolicy: 'network-only',
//   })

//   return { loading, error, data }
// }

export function useGetProfile(userId) {
  const { loading, error, data, networkStatus, refetch } = useQuery(
    GET_PROFILE,
    {
      variables: { id: userId },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
    }
  )
  return { loading, error, data, networkStatus, refetch }
}

export function useGetScratchCardData(userId) {
  const { loading, error, data, refetch } = useQuery(GET_SCRATCH_CARDS_DATA, {
    variables: { id: userId },
    fetchPolicy: 'network-only',
  })

  return { loading, error, data, refetch }
}

export function useGetFaqs() {
  const { loading, error, data, refetch } = useQuery(GET_FAQS)

  return { loading, error, data, refetch }
}

// export function useGetResult(userId, quizId) {
//   const { loading, error, data } = useQuery(GET_RESULT, {
//     variables: { filter: { userId, quizId }, quizId },
//   })
//   return { loading, error, data }
// }

// export function useGetQuizQuestions(userId, quizId) {
//   const { loading, error, data } = useQuery(GET_QUIZ_QUESTIONS, {
//     variables: { userId, quizId },
//     fetchPolicy: 'network-only',
//   })

//   return { loading, error, data }
// }

export function useGenerateOtp() {
  const [generateOtp, { loading, error, data }] = useMutation(CREATE_OTP)
  const genOtp = (phoneNumber, login = true) =>
    generateOtp({ variables: { phoneNumber, login } })

  return [genOtp, { loading, error, data }]
}

export function useVerifyOtp() {
  const [verifyOtp, { loading, error, data }] = useMutation(VERIFY_OTP)
  const verOtp = (otp, phoneNumber) =>
    verifyOtp({ variables: { otp, phoneNumber } })

  return [verOtp, { loading, error, data }]
}

// export function useGetRewards(userId, identifier, month) {
//   const { loading, error, data, refetch } = useQuery(GET_REWARDS_DATA, {
//     variables: {
//       userId,
//       identifier,
//       month,
//       filter: { status: true },
//       ordersFilter: { user: userId },
//     },
//     fetchPolicy: 'network-only',
//   })

//   return { loading, error, data, refetch }
// }

// export function useGetDashboard(userId) {
//   const { loading, error, data, refetch } = useQuery(GET_DASHBOARD_DATA, {
//     variables: {
//       userId,
//     },
//     fetchPolicy: 'network-only',
//   })

//   return { loading, error, data, refetch }
// }

export function useCreateReward(userId) {
  const [newReward, { loading, error, data }] = useMutation(CREATE_REWARD, {
    // refetchQueries: () => {
    //   return [
    //     {
    //       query: GET_EVENTS,
    //       variables: { filter: { userId, type: 'reward' } },
    //     },
    //     {
    //       query: GET_REWARDS_DATA,
    //       variables: { userId },
    //     },
    //   ]
    // },
  })
  const createReward = (rewardData) =>
    newReward({ variables: { ...rewardData } })
  return [createReward, { loading, error, data }]
}

// export function useGetReward(userId) {
//   const { loading, error, data } = useQuery(GET_REWARD, {
//     variables: { filter: { user: userId } },
//     fetchPolicy: 'cache-and-network',
//   })

//   return { loading, error, data }
// }

// export function useGetTags(type) {
//   const { loading, error, data } = useQuery(GET_TAGS, {
//     variables: { filter: { type } },
//     fetchPolicy: 'cache-and-network',
//   })

//   return { loading, error, data }
// }

export function useGetVideo(id, tab) {
  const { loading, error, data } = useQuery(GET_VIDEO, {
    variables: { id, tab },
    fetchPolicy: 'network-only',
  })

  return { loading, error, data }
}

export function useSetOnBoardingAge() {
  const [setAge, { loading, error, data }] = useMutation(UPDATE_USER_AGE)

  const setNewAge = (id, age) =>
    setAge({
      variables: { id, age },
    })

  return [setNewAge, { loading, error, data }]
}

export function useVideoData() {
  const [video, { loading, error, data }] = useMutation(UPDATE_VIDEO_DATA)

  const SetVideoData = (userId, videoId, percentage) =>
    video({
      variables: { userId, videoId, percentage },
    })

  return [SetVideoData, { loading, error, data }]
}

export function useSubmitQuizQuestion(userId, number) {
  const [answer, { loading, error, data }] = useMutation(
    SUBMIT_QUIZ_QUES_RESULT,
    {
      refetchQueries: () => {
        return [
          {
            query: GET_QUIZ_QUESTION,
            variables: { userId },
          },
        ]
      },
    }
  )
  const submitAnswer = (userId, selectedIndex, correct) =>
    answer({
      variables: { userId, selectedIndex, correct },
    })

  return [submitAnswer, { loading, error, data }]
}

export function useGetBanner(bannerType) {
  const { loading, error, data } = useQuery(BANNER, {
    variables: { bannerType },
    fetchPolicy: 'cache-and-network',
  })
  return { loading, error, data }
}

export function useGetBonusActivity(userId) {
  const { loading, error, data } = useQuery(BONUS_ACTIVITY, {
    variables: { userId },
  })
  return { loading, error, data }
}

export function useGetQuizQuestion(userId) {
  const { loading, error, data, refetch } = useQuery(GET_QUIZ_QUESTION, {
    variables: { userId },
    fetchPolicy: 'cache-and-network',
  })

  return { loading, error, data, refetch }
}

export function useGetQuizQuestionByNumber(userId, number) {
  const { loading, error, data } = useQuery(GET_QUESTION_BY_NUMBER, {
    variables: { userId, number },
    fetchPolicy: 'network-only',
  })
  return { loading, error, data }
}

export function useGetWorksheet(id, subject) {
  const { loading, error, data } = useQuery(GET_WORKSHEET, {
    variables: { id, subject },
    fetchPolicy: 'network-only',
  })
  return { loading, error, data }
}

export function useGetKidAssessment(id, subject) {
  const { loading, error, data } = useQuery(GET_KID_ASSESSMENT_QUESTION, {
    variables: { id, subject },
    fetchPolicy: 'network-only',
  })
  return { loading, error, data }
}

export function useGetParentScreenQuestions(id) {
  const { loading, error, data, refetch } = useQuery(GET_PARENT_SCREEN, {
    variables: { id },
    fetchPolicy: 'cache-and-network',
  })

  return { loading, error, data, refetch }
}

export function useSubmitScreener() {
  const [submitScreener, { loading, error, data }] = useMutation(
    SUBMIT_SCREENER
  )
  const postScreener = (id, result, answer) =>
    submitScreener({ variables: { id, result, answer } })

  return [postScreener, { loading, error, data }]
}

export function useWorsheetData() {
  const [submitData, { loading, error, data }] = useMutation(
    SEND_WORKSHEET_DATA
  )

  const submitWorksheetStatus = (userId, sheetId, status) =>
    submitData({
      variables: { userId, sheetId, status },
    })

  return [submitWorksheetStatus, { loading, error, data }]
}

export function useQuizData() {
  const [submitData, { loading, error, data }] = useMutation(SEND_QUIZ_DATA)

  const submitQuizStatus = (userId, questionId, status) =>
    submitData({ variables: { userId, questionId, status } })

  return [submitQuizStatus, { loading, error, data }]
}

export function useAssessmentData() {
  const [submitData, { loading, error, data }] = useMutation(
    SEND_ASSESSMENT_DATA
  )

  const submitAssessmentStatus = (userId, sheetId, status) =>
    submitData({
      variables: { userId, sheetId, status },
    })

  return [submitAssessmentStatus, { loading, error, data }]
}

export function useBonusData() {
  const [submitData, { loading, error, data }] = useMutation(SEND_BONUS_DATA)

  const submitBonusData = (userId, activityType) =>
    submitData({
      variables: {
        userId,
        activityType,
      },
    })

  return [submitBonusData, { loading, error, data }]
}

export function useVideoDataStatus() {
  const [submitData, { loading, error, data }] = useMutation(SEND_VIDEOS_DATA)

  const submitVideoData = (userId, videoId, status) => {
    submitData({ variables: { userId, videoId, status } })
  }

  return [submitVideoData, { loading, error, data }]
}

export function useParentScreenerData() {
  const [submitData, { loading, error, data }] = useMutation(SEND_PARENT_DATA)

  const submitParentData = (userId, screenerId, status) => {
    submitData({ variables: { userId, screenerId, status } })
  }

  return [submitParentData, { loading, error, data }]
}

export function useGetSheetbyId(userId, sheetId) {
  const { loading, error, data, refetch } = useQuery(GET_SHEET_BY_ID, {
    variables: { userId, sheetId },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  })
  return { loading, error, data, refetch }
}

export function useSubmitWorksheet(userId, sheetId) {
  const [submitWorksheetData, { loading, error, data }] = useMutation(
    SUBMIT_WORKSHEET,
    {
      refetchQueries: () => {
        return [
          {
            query: GET_SHEET_BY_ID,
            variables: { userId, sheetId },
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
          },
        ]
      },
    }
  )
  const submitData = (userId, id, answer) =>
    submitWorksheetData({
      variables: { userId, sheetId: id, answer },
    })
  return [submitData, { loading, error, data }]
}

export function useGetQuizReward(filter) {
  const { loading, error, data } = useQuery(GET_REWARDS, {
    variables: { filter: { status: true } },
    fetchPolicy: 'cache-and-network',
  })
  return { loading, error, data }
}

export function useChildPerformance(userId) {
  const { loading, error, data } = useQuery(GET_CHILD_PERFORMANCE, {
    variables: { userId },
    fetchPolicy: 'cache-and-network',
  })
  return { loading, error, data }
}

export function useFamilyProgress(userId) {
  const { loading, error, data } = useQuery(GET_FAMILY_PROGRESS, {
    variables: { userId },
    fetchPolicy: 'cache-and-network',
  })
  return { loading, error, data }
}

export function useGetWinnerScreen(month, limit, skip) {
  const { loading, error, data } = useQuery(GET_WINNER_SCREEN, {
    variables: { month, filter: { limit, skip } },
    fetchPolicy: 'cache-and-network',
  })
  return { loading, error, data }
}

export function useAppLeaderBoard(userId) {
  const { loading, error, data } = useQuery(GET_LEADERBOARDS_DATA, {
    variables: { userId },
    fetchPolicy: 'cache-and-network',
  })
  return { loading, error, data }
}

export function useGetWeeklyVideoStatus(userId) {
  const { loading, error, data } = useQuery(GET_WEEKLY_VIDEOS_STATUS, {
    variables: { userId },
    fetchPolicy: 'cache-and-network',
  })
  return { loading, error, data }
}

// export function useGetScratchCardData(userId) {
//   const { loading, error, data } = useQuery(GET_SCRATCH_CARDS_DATA, {
//     variables: { userId },
//     fetchPolicy: 'cache-and-network',
//   })
//   return { loading, error, data }
// }

export function useGetWeeklyQuizStatus(userId) {
  const { loading, error, data } = useQuery(GET_WEEKLY_QUIZ_STATUS, {
    variables: { userId },
    fetchPolicy: 'cache-and-network',
  })
  return { loading, error, data }
}

export function useGetHomeBanners() {
  const { loading, error, data } = useQuery(GET_HOME_BANNERS, {
    fetchPolicy: 'cache-and-network',
  })
  return { loading, error, data }
}

export function useGetWeeklyWorksheetStatus(userId) {
  const { loading, error, data } = useQuery(GET_WEEKLY_WORKSHEET_STATUS, {
    variables: { userId },
    fetchPolicy: 'cache-and-network',
  })
  return { loading, error, data }
}

export function useGetCurrentWeek(userId) {
  const { loading, error, data } = useQuery(GET_CURRENT_WEEK, {
    variables: { userId },
    fetchPolicy: 'cache-and-network',
  })
  return { loading, error, data }
}

export function useGetMonthlyLeaderboard(userId) {
  const { loading, error, data } = useQuery(GET_MONTHLY_LEADERBOARD, {
    variables: { userId },
    fetchPolicy: 'cache-and-network',
  })
  return { loading, error, data }
}

export function usePointsAward() {
  const [rewardsData, { loading, error, data }] = useMutation(GET_APP_REWARDS)

  const rewards = (userId, reason) =>
    rewardsData({ variables: { userId, reason } })

  return [rewards, { loading, error, data }]
}

// export function useSubmitScreener() {
//   const [submitScreener, { loading, error, data }] = useMutation(
//     SUBMIT_SCREENER
//   )
//   const postScreener = (id, result, answer) =>
//     submitScreener({ variables: { id, result, answer } })

//   return [postScreener, { loading, error, data }]
// }

// export function usePointsAward(userId, reason) {
//   const { loading, error, data } = useQuery(GET_APP_REWARDS, {
//     variables: { userId, reason },
//     fetchPolicy: 'cache-and-network',
//   })
//   return { loading, error, data }
// }

// export function useGetQuestionNumber(userId,number){
//   const {loading,error,data}=useLazyQuery(GET_QUESTION_BY_NUMBER)
// }

// export function useGetQuizQuestionByNumber(userId, number) {
//   const { loading, error, data } = useQuery(GET_QUESTION_BY_NUMBER, {
//     variables: { userId, number },
//     fetchPolicy: 'network-only',
//   })
//   return { loading, error, data }
// }

export function useSetTimeData() {
  const [setTime, { loading, error, data }] = useMutation(SUBMIT_TIMEDATA)

  const setNewTime = (userId, type, time, id, month) =>
    setTime({
      variables: {
        userId,
        type,
        time,
        _id: id,
        month,
      },
    })

  return [setNewTime, { loading, error, data }]
}

export function useGetBannerCarousel() {
  const { loading, error, data } = useQuery(GET_BANNER_CAROUSEL)

  return { loading, error, data }
}
